import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { X } from 'react-bootstrap-icons';
import { googleLogin } from '../actions/auth';
import GoogleSignIn from './GoogleSignIn';
import { ErrorMessage } from './ErrorMessage';
import '../styles/sign-in.css';

function SignInModal({ open, onClose, googleLogin, isAuthenticated }) {
  const [errorMessages, setErrorMessages] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      setErrorMessages(null);
      return undefined;
    }
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  useEffect(() => {
    if (open && isAuthenticated) {
      onClose();
      navigate('/chat');
    }
  }, [open, isAuthenticated, onClose, navigate]);

  const handleCredential = useCallback(
    async (payload) => {
      setErrorMessages(null);
      const result = await googleLogin(payload);
      if (result === 'success') {
        onClose();
        navigate('/chat');
        return;
      }
      setErrorMessages(
        typeof result === 'string' && result !== 'error' ? result : 'Sign in failed.'
      );
    },
    [googleLogin, navigate, onClose]
  );

  const handleError = useCallback((message) => {
    setErrorMessages(message);
  }, []);

  if (!open) return null;

  return (
    <div
      className="signin-modal"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="signin-modal__panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="signin-modal-title"
      >
        <button
          type="button"
          className="signin-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <h1 id="signin-modal-title" className="signin-modal__title">
          Welcome
        </h1>
        <p className="signin-modal__subtitle">
          Sign in to SchoolCracked with your Google account
        </p>

        {errorMessages && <ErrorMessage message={errorMessages} />}

        <div className="signin-modal__google">
          <GoogleSignIn onCredential={handleCredential} onError={handleError} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { googleLogin })(SignInModal);
